'use strict';

import React from 'react';
import PropTypes from 'prop-types';

class RadioGroup extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      value: props.value
    };

    this.items = props.items;
    this.name = props.name;
    this.onUpdate = props.onUpdate;
  }

  shouldComponentUpdate (nextProps, nextState) {
    return nextProps.value !== this.state.value;
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        value: nextProps.value
      });
    }
  }

  render () {
    return (
      <div className={'radio-group ' + this.name}>
        {
          this.items.map(item => {
            return (
              <label
                key={item.value}
                className={'radiobutton__box' + (item.value == this.state.value ? ' radiobutton__tick' : '')}
                onClick={(e) => {
                  e.preventDefault();
                  this.onUpdate(this.name, item.value);
                }}>
                <span className='checkbox__title'>{ item.label }</span>
              </label>
            );
          })
        }
      </div>
    );
  }
}

RadioGroup.propTypes = {
  items: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,                       // имя свойства, которое меняет селект
  onUpdate: PropTypes.func.isRequired,                     // callback(name, item.value)
  value: PropTypes.oneOfType([                             // текущиее выбранное значение
    PropTypes.string,
    PropTypes.number
  ])
};

RadioGroup.defaultProps = {
  value: null
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/ui/Controls/RadioGroup.jsx